var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer",style:({
    'background-color': `${_vm.appConfig.color.mainDark} !important`,
    'color': _vm.appConfig.color.textLight
  }),attrs:{"dark":"","height":_vm.height}},[_c('p',{staticClass:"footer__content pt-1"},[_vm._v(" "+_vm._s(_vm.appConfig.footerText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }